import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { XMarkIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';

const MobileBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();

  // Only show banner on app routes (not marketing pages)
  const showOnRoute = location.pathname.startsWith('/app') ||
    location.pathname.startsWith('/super-admin') ||
    location.pathname === '/student-dashboard';

  // Don't show banner if user has dismissed it in this session or not on app route
  if (!isVisible || !showOnRoute) return null;

  return (
    <div className="lg:hidden bg-blue-600 dark:bg-blue-700 text-white">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <ComputerDesktopIcon className="h-5 w-5 flex-shrink-0" />
            <div className="text-sm">
              <p className="font-medium">
                For the best experience, please use the desktop version
              </p>
              <p className="text-blue-100 dark:text-blue-200 text-xs">
                Enhanced features and optimized interface available on larger screens
              </p>
            </div>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="flex-shrink-0 p-1 rounded-md hover:bg-blue-700 dark:hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-white"
            aria-label="Dismiss banner"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileBanner;